var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.997 29.496"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "streamline-icon-pin@140x140",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 66",
    d: "M5.249 9.999A4.749 4.749 0 109.998 5.25a4.749 4.749 0 00-4.749 4.749z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 67",
    d: "M9.999.5a9.5 9.5 0 019.5 9.5c0 4.315-6.426 15.134-8.707 18.573a.95.95 0 01-1.583 0C6.928 25.135.502 14.315.502 10a9.5 9.5 0 019.5-9.5z"
  }))));
}

export default __webpack_public_path__ + "6b23b81554479f4d0b4fefe4bb6aad5e.svg";
export { SvgPin as ReactComponent };